module.exports = __webpack_public_path__ + "static/media/audience-restriction.a7f0bfb8.svg";